export default "__VITE_ASSET__DgW8ZBV2__"